import { useCallback, useState } from 'react'

import { Button, DefaultPopover, Separator, cn } from 'twyne-new.ui'

import { createDefaultChart } from '../utils/constants'
import { useCustomReportStore } from '../store'

import ChartForm, { isChartFormValid } from './ChartForm'

export const CHART_POPOVER_CONTENT_CLASS = 'w-80 p-4 max-h-none overflow-visible overflow-x-hidden'

export default function AddChartPopover() {
  const {
    config: { value: config },
    charts: { add },
  } = useCustomReportStore()

  const [open, setOpen] = useState(false)
  const [form, setForm] = useState(() => createDefaultChart(config))

  const handleOpenChange = useCallback(nextOpen => {
    if (nextOpen) setForm(createDefaultChart(config))
    setOpen(nextOpen)
  }, [config])

  const handleAdd = useCallback(() => {
    if (!isChartFormValid(form)) return

    add({ ...form, name: (form.name || '').trim() })
    setOpen(false)
  }, [add, form])

  return (
    <DefaultPopover
      title="Add chart"
      wrapperProps={{ open, onOpenChange: handleOpenChange }}
      contentProps={{
        className: cn(CHART_POPOVER_CONTENT_CLASS),
        align: 'start',
      }}
      trigger={
        <Button size="sm" variant="outline" className="h-9">
          Add chart
        </Button>
      }
    >
      <div className="flex flex-col gap-4 min-w-0">
        <ChartForm config={config} form={form} setForm={setForm} />
        <Separator className="my-0" />
        <div className="flex justify-end gap-2">
          <Button size="sm" variant="ghost" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            size="sm"
            color="accent"
            disabled={!isChartFormValid(form)}
            onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
    </DefaultPopover>
  )
}
